import { useMemo } from 'react';
import { useLocation } from 'react-router-dom';
import { ORG_ROUTE_ACCESS } from '@/config/routeAccessRegistry';
import {
  resolvePageAccess,
  resolveRouteAccessRule,
  type PageAccess,
} from '@/config/routeAccessUtils';
import { usePermissions } from '@/hooks/usePermissions';

export function usePageAccess(pathname?: string): PageAccess & { rule: ReturnType<typeof resolveRouteAccessRule> } {
  const location = useLocation();
  const path = pathname ?? location.pathname;
  const { has } = usePermissions();

  return useMemo(() => {
    const rule = resolveRouteAccessRule(path, ORG_ROUTE_ACCESS);
    return { ...resolvePageAccess(rule, has), rule };
  }, [path, has]);
}
